export default __webpack_public_path__ + "static/assets/b5d5d8bafc7b437f4d05d0b714838c39.png";